import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import {RouterOutlet} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'sp-root',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  private readonly translate = inject(TranslateService);
  private readonly iconRegistry = inject(MatIconRegistry);
  
  constructor() {
    this.translate.setFallbackLang('de');
    this.iconRegistry.setDefaultFontSetClass('material-symbols-outlined');
  }
}
